import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector }   from 'react-redux';
import { fetchProfile, updateProfile } from '../../store/reducers/profileSlice';
import { FiEdit2, FiCheck, FiX }      from 'react-icons/fi';

export default function CompleteProfile() {
  const dispatch = useDispatch();

  const { user: savedUser, status, error } = useSelector(s => s.profile);
  const authUser = useSelector(s => s.auth.userInfo);

  const [editField, setEditField] = useState(null);
  const [form, setForm] = useState({
    name:  '',
    gender:'',
    dob:   '',
    phone: ''
  });

  // seed and fetch
  useEffect(() => {
    if (authUser) {
      setForm(f => ({
        ...f,
        name:   authUser.name  || f.name,
        gender: authUser.gender|| f.gender,
        dob: authUser.dob 
               ? authUser.dob.slice(0,10) 
               : f.dob,
        phone:  authUser.phone || f.phone
      }));
    }
    dispatch(fetchProfile());
  }, [dispatch, authUser]);

  // when savedUser arrives
  useEffect(() => {
    if (status === 'succeeded' && savedUser) {
      setForm({
        name:   savedUser.name   || form.name,
        gender: savedUser.gender || form.gender,
        dob:    savedUser.dob
               ? savedUser.dob.slice(0,10)
               : form.dob,
        phone:  savedUser.phone  || form.phone
      });
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [status, savedUser]);

  const onChange = e => {
    setForm(f => ({ ...f, [e.target.name]: e.target.value }));
  };

  const save = async key => {
    try {
      await dispatch(updateProfile({ [key]: form[key] })).unwrap();
      setEditField(null);
    } catch (err) {
      console.error('Update error:', err);
      alert(err.error || 'Update failed');
    }
  };

  if (status === 'loading') return <div>Loading profile…</div>;
  if (status === 'failed')
    return <div className="text-red-600">Error: {error}</div>;

  const fields = [
    { key:'name',   label:'Name',          type:'text'   },
    { key:'gender', label:'Gender',        type:'select',
      options:['Male','Female','Rather not say'] },
    { key:'dob',    label:'Date of Birth', type:'date'   },
    { key:'phone',  label:'Phone Number',  type:'tel'    },
    { key:'email',  label:'Email',         type:'readonly'}
  ];

  return (
    <div className="p-6 bg-slate-100 min-h-[80vh]">
      {/* your tab nav… */}

      <div className="bg-white rounded-md p-6 space-y-4">
        <h2 className="text-xl font-semibold">Basic Details</h2>

        {fields.map(({ key, label, type, options }) => (
          <div
            key={key}
            className="flex justify-between items-center border rounded px-4 py-3"
          >
            <span className="text-slate-600">{label}</span>

            {editField === key ? (
              <div className="flex items-center gap-2">
                {type === 'select' ? (
                  <select
                    name={key}
                    value={form[key]}
                    onChange={onChange}
                    className="border px-2 py-1"
                  >
                    <option value="">— select —</option>
                    {options.map(opt => (
                      <option key={opt} value={opt}>{opt}</option>
                    ))}
                  </select>
                ) : type === 'date' ? (
                  <input
                    type="date"
                    name={key}
                    value={form[key]}
                    onChange={onChange}
                    className="border px-2 py-1"
                  />
                ) : type === 'readonly' ? (
                  <input
                    type="text"
                    readOnly
                    value={savedUser?.email || authUser?.email || ''}
                    className="border px-2 py-1 bg-gray-100"
                  />
                ) : (
                  <input
                    type={type}
                    name={key}
                    value={form[key]}
                    onChange={onChange}
                    className="border px-2 py-1"
                  />
                )}

                <button onClick={() => save(key)} className="text-green-600">
                  <FiCheck />
                </button>
                <button onClick={() => setEditField(null)} className="text-red-600">
                  <FiX />
                </button>
              </div>
            ) : (
              <div className="flex items-center gap-2">
                <span className="font-medium text-slate-800">
                  { key === 'email'
                    ? savedUser?.email || authUser?.email || '-'
                    : form[key] || '-'
                  }
                </span>
                {type !== 'readonly' && (
                  <button
                    onClick={() => setEditField(key)}
                    className="text-slate-400 hover:text-indigo-600"
                  >
                    <FiEdit2 />
                  </button>
                )}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
